var _path, _path2, _path3, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyHistory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 34C22 31.7909 23.7909 30 26 30H61.6C63.0772 30 64.4342 30.8142 65.1294 32.1176L70.8706 42.8824C71.5658 44.1858 72.9228 45 74.4 45H127C129.209 45 131 46.7909 131 49V126C131 128.209 129.209 130 127 130H22V34Z",
    fill: "#E7E9EC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4126 60.2987C34.7524 58.3901 36.412 57 38.3506 57H141.612C142.857 57 143.8 58.1251 143.581 59.3506L131.587 126.701C131.248 128.61 129.588 130 127.649 130H22L34.4126 60.2987Z",
    fill: "#F4F5F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0239 71.5907C44.6112 70.033 46.1019 69.002 47.7667 69.002H151.108C152.506 69.002 153.473 70.3995 152.98 71.7076L131.976 127.413C131.389 128.971 129.898 130.002 128.233 130.002H22L44.0239 71.5907Z",
    fill: "#1E95F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#empty_history_clip_0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.3616 108.562L97.4241 105.036C97.5723 104.77 97.5723 104.45 97.4241 104.197L96.777 103.08L93.3262 108.988H94.6337C94.9303 108.988 95.2134 108.828 95.3616 108.562Z",
    fill: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.5159 108.561L99.0147 107.723C99.163 107.456 99.163 107.137 99.0147 106.884L98.3677 105.78L96.4805 109H97.788C98.0711 108.987 98.3542 108.827 98.5159 108.561Z",
    fill: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7599 108.988L78.309 103.08L77.662 104.197C77.5137 104.463 77.5137 104.783 77.662 105.036L79.7109 108.562C79.8592 108.828 80.1423 108.988 80.4523 108.988H81.7599Z",
    fill: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7582 105.726L76.1112 106.831C75.9629 107.097 75.9629 107.416 76.1112 107.669L76.6234 108.56C76.7717 108.827 77.0548 108.986 77.3648 108.986H78.6724L76.7582 105.726Z",
    fill: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1958 108.986H91.4789C91.7889 108.986 92.072 108.827 92.2203 108.561L95.8599 102.333C96.0081 102.067 96.0081 101.748 95.8599 101.495L95.2128 100.377L90.6836 108.108L91.1958 108.986Z",
    fill: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8995 108.987L80.3838 101.256H79.3593L79.2245 101.509C79.0762 101.775 79.0762 102.094 79.2245 102.347L82.8641 108.561C83.0123 108.827 83.2954 108.987 83.6055 108.987H84.8995Z",
    fill: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0088 106.963L94.282 99.6573C94.4302 99.3911 94.4302 99.0718 94.282 98.8189L93.6349 97.7012L89.1191 105.432L90.0088 106.963Z",
    fill: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7324 101.256L86.0056 108.561C86.1538 108.827 86.4369 108.987 86.7469 108.987H88.0545L83.5252 101.256H81.7324Z",
    fill: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6794 101.256H84.873L89.1462 108.561C89.2945 108.827 89.5775 108.987 89.8876 108.987H91.1951L86.6794 101.256Z",
    fill: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.6049 91.6611H85.48C85.17 91.6611 84.9004 91.8208 84.7386 92.0869L84.0781 93.1914H90.9933L90.3463 92.0736C90.1845 91.8208 89.9014 91.6611 89.6049 91.6611Z",
    fill: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.0535 89H87.0291C86.719 89 86.4494 89.1597 86.2877 89.4258L85.6406 90.5436H89.442L88.7949 89.4258C88.6466 89.1597 88.3636 89 88.0535 89Z",
    fill: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0573 95.0145L91.909 94.7749C91.7607 94.5088 91.4776 94.3491 91.1676 94.3491H83.8884C83.5784 94.3491 83.3088 94.5088 83.147 94.7749L82.5 95.8927H91.545L92.0573 95.0145Z",
    fill: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.8722 97.0371H82.3259C82.0159 97.0371 81.7463 97.1968 81.5845 97.4629L80.9375 98.5807H89.9825L90.8722 97.0371Z",
    fill: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0199 100.139L79.3594 101.256H88.4044L89.3076 99.7129H80.7613C80.4512 99.7262 80.1682 99.8859 80.0199 100.139Z",
    fill: "#E7E9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.0568 95.0156L87.541 102.747L88.4442 104.29L92.7173 96.985C92.8656 96.7189 92.8656 96.3995 92.7173 96.1467L92.0568 95.0156Z",
    fill: "#E7E9EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "empty_history_clip_0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.125,
    height: 20,
    fill: "white",
    transform: "translate(76 89)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyHistory);
export default __webpack_public_path__ + "static/media/empty-history.6e49358c.svg";
export { ForwardRef as ReactComponent };